import React from "react"
import BaseIcon from "../../BaseIcon"

export default class CollapseAllIcon extends BaseIcon {
  getChildren = () => [
    <path
      fill={this.getColor()}
      d="M0,10V9H16v1ZM0,7H16V8H0Zm5,9,3-3,3,3M11,1,8,4,5,1"
    />,
  ]
  getViewBox = () => "0 0 16 16"
}
